<template>
  <span
    class="oct-chip"
    role="row"
    :aria-selected="selected ? 'true' : selected"
  >
    {{ text }}
    <slot />
  </span>
</template>

<script>
export default {
  name: 'OctChip',
  props: {
    /** Text */
    text: {
      type: String,
      default: ''
    },
    /** Whether selected */
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-chip {
  font-family: $font-family-sans-serif;
  font-size: oct-rem(18);
  font-style: normal;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  color: $oct-theme--primary;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0 10px-1;
  appearance: none;
  border: 1.5px solid $oct-theme--primary;
  outline: none;
  border-radius: 15px;
  box-sizing: border-box;
  vertical-align: middle;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0,0,0,0);

  &[aria-selected="true"] {
    color: $oct-theme--on-primary;
    background-color: $oct-theme--primary;

    &:hover {
      color: $oct-theme--primary;
      background-color: transparent;
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(23);
  height: 36px;
  padding: 0 12px-1;
  border-radius: 18px;
}
}

a.oct-chip {
  pointer-events: auto;

  &:hover {
    color: $oct-theme--on-primary;
    background-color: $oct-theme--primary;
  }
}
</style>
